import { useEffect, useRef } from 'react';

// Load the WebGL scene independently so the page and player can render immediately.
const MusicParticles = () => {
  const hostRef = useRef(null);
  useEffect(() => {
    let cancelled = false;
    let dispose;
    import('../lib/musicScene').then(({ createMusicScene }) => {
      if (!cancelled && hostRef.current) dispose = createMusicScene(hostRef.current);
    }).catch(() => { /* The hero remains usable when WebGL is unavailable. */ });
    return () => { cancelled = true; dispose?.(); };
  }, []);
  return <div ref={hostRef} className="music-scene" aria-hidden="true" data-testid="music-scene" />;
};
export default MusicParticles;
